import { getWebHostServices, HostServiceResponse } from "api"
import { useEffect, useState } from "react"

export function useHostExtras(hostLocationName: string) {
  const [extras, setExtras] = useState<HostServiceResponse[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!hostLocationName) return

    let cancelled = false
    setLoading(true)

    getWebHostServices(hostLocationName)
      .then((res) => {
        if (!cancelled && res.data?.body) {
          setExtras(res.data.body)
        }
      })
      .catch(() => {
        // Silently fail — extras section just won't show
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [hostLocationName])

  return { extras, loading }
}
